<template>
  <div class="container">
  <div class="row mt-5">
    <div class="mb-3">
  <label for="exampleFormControlInput1" class="form-label">Price peek</label>
  <input type="number" class="form-control" id="exampleFormControlInput1" v-model="price">
  <div class="row mt-3">
    <div class="col-md-6">
      <div class="row">
        <div class="col-md-12">Buy</div>
        <div class="col-md-2"><input type="number" class="form-control" id="exampleFormControlInput1" v-model="one"></div>
    <div class="col-md-10"><div class="col-auto">
    <button type="submit" class="btn btn-success mb-3" style="width:150px">{{(price-((price*one)/100)).toFixed(2)}}</button>
  </div></div>
  <div class="col-md-2"><input type="number" class="form-control" id="exampleFormControlInput1" v-model="two"></div>
    <div class="col-md-10"><div class="col-auto">
    <button type="submit" class="btn btn-success mb-3" style="width:150px">{{(price-((price*two)/100)).toFixed(2)}}</button>
  </div></div>
  <div class="col-md-2"><input type="number" class="form-control" id="exampleFormControlInput1" v-model="three"></div>
    <div class="col-md-10"><div class="col-auto">
    <button type="submit" class="btn btn-success mb-3" style="width:150px">{{(price-((price*three)/100)).toFixed(2)}}</button>
  </div></div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="row">
        <div class="col-md-12">Sell</div>
        <div class="col-md-2"><input type="number" class="form-control" id="exampleFormControlInput1" v-model="onesell"></div>
    <div class="col-md-10"><div class="col-auto">
    <button type="submit" class="btn btn-danger mb-3" style="width:150px">{{parseFloat((parseFloat(price)+parseFloat((price*onesell)/100))).toFixed(2)}}</button>
  </div></div>
  <div class="col-md-2"><input type="number" class="form-control" id="exampleFormControlInput1" v-model="twosell"></div>
    <div class="col-md-10"><div class="col-auto">
    <button type="submit" class="btn btn-danger mb-3" style="width:150px">{{parseFloat((parseFloat(price)+parseFloat((price*twosell)/100))).toFixed(2)}}</button>
  </div></div>
  <div class="col-md-2"><input type="number" class="form-control" id="exampleFormControlInput1" v-model="threesell"></div>
    <div class="col-md-10"><div class="col-auto">
    <button type="submit" class="btn btn-danger mb-3" style="width:150px">{{parseFloat((parseFloat(price)+parseFloat((price*threesell)/100))).toFixed(2)}}</button>
  </div></div>
      </div>
    </div>
  </div>
</div>
</div>
  </div>
</template>

<script>

export default {
  name: "Nav",
  props: {
    msg: String,
  },
  components:{
  },
  data() {
    return {
      list:[],
      price:'',
      one:30,
      two:40,
      three:50,
      onesell:30,
      twosell:40,
      threesell:50
    };
  },
  mounted() {
  
  },
  methods: {
    
  },
  computed: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
